<template>
  <div class="toast-wp" v-show="isShow">
    <div class="toast">
      {{toastMsg || '提示'}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    isTrigger: Boolean,
    toastMsg: String,
    ms: Number
  },
  data() {
    return {
      isShow: false
    }
  },
  methods: {

  },
  watch: {
    isTrigger() {
      this.isShow = true;
      setTimeout(() => {
        this.isShow = false;
      }, this.ms || 1500)

    }
  }
}
</script>

<style lang="less" scoped>
  .toast-wp {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }
  .toast {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 6*1.8rem /* 96/16 */;
    max-width: 80%;
    // height: 1.5*1.2rem /* 48/16 */;
    padding: .6875rem /* 11/16 */ 1rem;
    background-color: rgba(0, 0, 0, .6);
    border-radius: .375rem /* 6/16 */;
    font-size: 1rem /* 16/16 */;
    color: #fff;
    line-height: 1.5*1.2rem;
    text-align: center;
  }
</style>
